// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { t } from 'i18next';
import { takeEvery, call, put, select } from 'redux-saga/effects';
import { Api } from '../../../../services/config/Api';
import { RUNNER_PERMISSIONS_MAPPING } from '../../../../services/config/ApiConstants';
import { RUNNERS_PAGE_COUNT } from '../../../../services/config/FunctionalConstants';
import { ACL_PERMISSIONS } from '../../../../services/config/accessControl';
import { ScenariosUtils, ApiUtils } from '../../../../utils';
import { DATASET_ACTIONS_KEY } from '../../../commons/DatasetConstants';
import { DATASTORE_ACTIONS } from '../../../commons/DatastoreConstants';
import { RUNNER_ACTIONS_KEY } from '../../../commons/RunnerConstants';
import { dispatchSetApplicationErrorMessage } from '../../../dispatchers/app/ApplicationDispatcher';

const getDatasets = (state) => state?.dataset.list?.data;
const getCurrentWorkspace = (state) => state?.workspace?.current?.data;
const getUserEmail = (state) => state.auth.userEmail;
const getUserId = (state) => state.auth.userId;
export function* getAllRunners(organizationId) {
  const datasets = yield select(getDatasets);
  const selectedWorkspace = yield select(getCurrentWorkspace);
  const userEmail = yield select(getUserEmail);
  const userId = yield select(getUserId);
  try {
    yield put({ type: DATASET_ACTIONS_KEY.RESET_DATASTORE_ASSOCIATED_RUNNERS });

    const { data: runnersList } = yield call(
      Api.Runners.listRunners,
      organizationId,
      selectedWorkspace?.id,
      0,
      RUNNERS_PAGE_COUNT
    );
    const etlAssociatedRunnersIds = datasets
      .filter(
        (dataset) =>
          dataset.main === true &&
          dataset.sourceType === 'ETL' &&
          selectedWorkspace?.linkedDatasetIdList?.includes(dataset.id)
      )
      .map((dataset) => dataset.source?.name);
    const etlAssociatedRunners = runnersList.filter((runner) => etlAssociatedRunnersIds.includes(runner.id));
    etlAssociatedRunners.forEach((runner) => {
      runner.parametersValues = ApiUtils.formatParametersFromApi(runner.parametersValues);
    });
    runnersList.forEach((runner) =>
      ScenariosUtils.patchScenarioWithCurrentUserPermissions(runner, userEmail, userId, RUNNER_PERMISSIONS_MAPPING)
    );
    const datastoreRunners = runnersList
      .filter((runner) => runner.security.currentUserPermissions.includes(ACL_PERMISSIONS.RUNNER.READ))
      .filter((runner) => ['datastore_checking', 'push_datastore'].includes(runner.runTemplateId));
    yield put({ type: DATASTORE_ACTIONS.SET_RUNNERS, runners: datastoreRunners });
    yield put({
      type: RUNNER_ACTIONS_KEY.SET_ETL_RUNNERS,
      data: etlAssociatedRunners,
    });
  } catch (error) {
    console.error(error);
    yield put(
      dispatchSetApplicationErrorMessage(
        error,
        t('commoncomponents.banner.getAllRunnersError', 'Unexpected error while loading runners')
      )
    );
  }
}

function* getAllRunnersData() {
  yield takeEvery(RUNNER_ACTIONS_KEY.TRIGGER_SAGA_GET_RUNNERS, getAllRunners);
}
export default getAllRunnersData;
